import PropTypes from "prop-types";
import React from "react";

export const FormTextInput = React.forwardRef(
  (
    {
      labelName,
      id,
      value,
      disabledCheck = false,
      required = false,
      requiredAny = false,
      onChange,
      error,
      ...props
    },
    ref
  ) => {
    let bgDisable = disabledCheck ? "bg-gray-300 cursor-not-allowed" : "";
    let borderColor = error ? "border-red-500" : "border-gray-300";
    let borderFocus = error ? "border-red-500" : "border-teal-300";

    return (
      <div className="my-2 mt-0 w-full">
        <label className="block font-normal text-lg" htmlFor={id}>
          {labelName}
          {required && (
            <sup className="text-red-500 font-bold text-lg ml-1">*</sup>
          )}
          {requiredAny && (
            <sup className="text-red-500 font-bold text-lg ml-1">**</sup>
          )}
        </label>

        <input
          className={`form-control mt-1 block w-full p-2 border ${borderColor} rounded-sm shadow-sm focus:${borderFocus} focus:ring-0 focus:outline-none ${bgDisable}`}
          type="text"
          id={id}
          ref={ref}
          value={value}
          onChange={onChange}
          {...props}
          disabled={disabledCheck}
        />
        {error && <span className="text-red-500 text-sm">{error.message}</span>}
      </div>
    );
  }
);

FormTextInput.propTypes = {
  labelName: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabledCheck: PropTypes.bool,
  required: PropTypes.bool,
  requiredAny: PropTypes.bool,
  error: PropTypes.object,
};
